"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLocationDetailsSelector = exports.useFilteredLocationsSelector = exports.useSearchSelector = void 0;

var _index = require("../index");

/**
 * Returns the survey questions
 */
var useSearchSelector = function useSearchSelector() {
  return (0, _index.useShallowEqualSelector)(function (_ref) {
    var _ref$locations = _ref.locations,
        loading = _ref$locations.loading,
        searchRadius = _ref$locations.searchRadius,
        lastSearch = _ref$locations.lastSearch,
        filter = _ref$locations.filter,
        lastSearchId = _ref$locations.lastSearchId,
        lastSearchQuery = _ref$locations.lastSearchQuery,
        lastPageViewId = _ref$locations.lastPageViewId;
    return {
      loading: loading,
      searchRadius: searchRadius,
      lastSearch: lastSearch,
      filter: filter,
      lastSearchId: lastSearchId,
      lastSearchQuery: lastSearchQuery,
      lastPageViewId: lastPageViewId
    };
  });
};
/**
 * Returns the filtered locations
 */


exports.useSearchSelector = useSearchSelector;

var useFilteredLocationsSelector = function useFilteredLocationsSelector() {
  return (0, _index.useShallowEqualSelector)(function (_ref2) {
    var _ref2$locations = _ref2.locations,
        loading = _ref2$locations.loading,
        filteredLocationIds = _ref2$locations.filteredLocationIds,
        locationMap = _ref2$locations.locationMap,
        filteredLocationIdsString = _ref2$locations.filteredLocationIdsString;
    return {
      loading: loading,
      filteredLocations: filteredLocationIds ? filteredLocationIds.map(function (id) {
        return locationMap[id];
      }) : null,
      filteredLocationIdsString: filteredLocationIdsString
    };
  });
};
/**
 * Returns the filtered locations
 */


exports.useFilteredLocationsSelector = useFilteredLocationsSelector;

var useLocationDetailsSelector = function useLocationDetailsSelector(locationId) {
  return (0, _index.useShallowEqualSelector)(function (_ref3) {
    var locationMap = _ref3.locations.locationMap;
    return locationMap[locationId];
  });
};

exports.useLocationDetailsSelector = useLocationDetailsSelector;